import styled, { css } from 'styled-components';
import { Text, theme } from '@frameio/vapor';
import { IconPeopleFill } from '@frameio/vapor-icons';
import { MemberEmail } from './MemberEmail';

const metaTextMixin = css`
  color: ${theme.colors.text.tertiary};
  display: inline-block;
  transition: color 0.2s ${theme.transitions.eases.primary};
`;

export const StyledMemberEmail = styled(MemberEmail)<{
  $preventLinebreak?: boolean;
}>`
  ${metaTextMixin}
  white-space: ${(p) => (p.$preventLinebreak ? 'nowrap' : 'normal')};
`;

export const StyledIconPeople = styled(IconPeopleFill)`
  color: ${theme.colors.icon.primary};
  margin-right: ${theme.spaces[4]};
  transition: color 0.2s ${theme.transitions.eases.primary};
`;

export const StyledTextForMemberCount = styled(Text)`
  flex-shrink: 1;
  ${metaTextMixin}
  position: relative;
`;

export const RowContainerButton = styled.button<{ $isHighlighted?: boolean }>`
  align-items: center;
  background: ${(p) =>
    p.$isHighlighted ? theme.colors.background.interactive.activated : 'none'};
  border: none;
  border-radius: ${theme.radii[6]};
  cursor: pointer;
  display: flex;
  height: ${theme.spaces[32]};
  min-width: 0;
  outline: 0;
  overflow: hidden;
  padding: 0 ${theme.spaces[4]} 0 ${theme.spaces[4]};
  transition: background-color 0.2s ${theme.transitions.eases.primary};
  width: 100%;

  &:hover,
  &:focus {
    background-color: ${theme.colors.background.interactive.hover};

    ${StyledTextForMemberCount},
    ${StyledIconPeople},
    ${StyledMemberEmail} {
      color: ${theme.colors.text.secondary};
    }
  }
`;

export const VisuallyHiddenText = styled.span`
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute !important;
  width: 1px;
`;
